export default {
    message: {
        'header': {
            'online': 'Trực tuyến'
        },
        'footer': {
            'home': 'Trang chủ',
            'points': '₫iểm',
            'vip_zone': 'Khu VIP',
            'order': 'đơn hàng',
            'account': 'Tài khoản'
        },
        'index': {
            'notice1': "Chúc mừng người chơi",
            'notice2': "'Tham gia, đã thắng",
            'notice3': "Chúc mừng cậu ấy nào!",
            // 'hot_spot': 'PHỔ BIẾN',
            'hot_spot': 'chơi trò chơi',
            'all_goods': 'Tất cả hàng hóa',
            'promotion_type': 'Loại khuyến mại',
            'partners': 'đối tác',
            'announcement': 'Thông báo',
            'cancel': 'Hủy',
            'travel_to': 'Chuyển đến',
            'ok': 'Gửi đi'
        },
        'goods': {
            'name1': 'Hoàn trả gấp đôi',
            'name2': 'Hoàn tiền mặt x2',
            'name3': 'Hoàn trả x70 (VIP1)',
            'name4': 'Hoàn tiền mặt x 72'

        },
        'img': {
            'banner1': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/b1e3c2a662e7333346ef1446db67b4c4.jpeg',
            'banner2': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/c9bf70863920f2a2ac53de21510d71c0.jpeg',
            'banner3': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/069a377136fa1234618c073b166f7ddd.jpeg',
            'banner4': 'https://manage.im2015.com//uploads/attach/2020/03/20200307/4a31597de7b1cc2674314bd8644415f2.jpg',
            'goods_img_10': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',
            'goods_img_50': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',
            'goods_img_5': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',
            'goods_img_150': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',
            'goods_img_25': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',
            'goods_img_500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',
            'goods_img_1500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',
            'goods_img_2500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',
            'goods_img_return': 'https://zhouyaoming.in2015.com//uploads/attach/2021/06/20210615/f5c725953f90a25e5111bd5b14d4952f.png'
        },
        'detail': {
            'please_select': 'Vui lòng chọn',
            'product_description': 'Mô tả sản phẩm',
            'check_out': 'Mua ngay',
            'original_price': 'Giá gốc',
            'inventory': 'Kho',
            'sold': 'Bán ra',
            'tip_start': 'Khuyến mại thành công sẽ nâng cấp thành giá trị ',
            'tip_end': 'Xu miễn phí',
            'quantity': 'Số lượng',
            'total_price': 'Tổng giá',
            'win_rate': 'Tỷ lệ thắng',
            'predict_type': 'Loại dự đoán',
            'member_shared': 'Thành viên chia sẻ được nhận',
            'share_now': 'Chia sẻ ngay',
            'copy_the_link': 'Sao chép liên kết',
            'send_to_friend': 'Gửi bạn bè',
            'copy_success': 'Sao chép thành công',
            'copy_error': 'Lỗi sao chép'
        },
        'integral': {
            'title': 'Khu đổi điểm',
            'search': 'Tìm thông tin sản phẩm',
            'points': 'điểm'
        },
        'vip_zone': {
            'title': 'Danh sách hàng hóa VIP',
            'price': 'Giá',
            'sales_volume': 'Doanh số'
        },
        'login': {
            'account_login': ['đăng nhập tài khoản'],
            'login': 'đăng nhập',
            'phone': 'Nhập số điện thoại của bạn',
            'pwd': 'điền mật khẩu của bạn',
            'no_account': 'Bạn đã có tài khoản chưa?',
            'forgot_password': 'Quên mật khẩu',
            'register': 'đăng ký'
        },
        'reset_pwd': {
            'title': 'Lấy lại mật khẩu',
            'get_verification_code': 'Lấy mã xác minh',
            'confirm': 'Xác nhận',
            'verification_code': 'Mã xác minh',
            'your_new_pwd': 'Mật khẩu mới của bạn',
            'reload': 'Tải lại',
            'msg_phone': 'Vui lòng nhập số điện thoại của bạn'
        },
        'register': {
            'register_account': 'đăng ký tài khoản',
            'account': 'Số điện thoại',
            'pwd': 'Mật khẩu đăng nhập',
            'con_pwd': 'Xác nhận mật khẩu',
            'register': 'đăng ký',
            'tip_account': 'Bạn đã có tài khoản chưa?',
            'by_click': 'Nhấp "đăng ký" chứng tỏ bạn đồng ý với điều khoản đăng ký của Trung tâm mua sắm thú vị',
            'privacy_policy': 'Chính sách bảo mật',
            'tip_wrong': '*Nhập sai số điện thoại sẽ không thể sử dụng trang web bình thường.',
            'msg_phone': 'Lỗi định dạng điện thoại'
        },
        'order': {
            'submit_order': 'Gửi đơn hàng',
            'item': 'Vật phẩm',
            'payment_method': 'Phương thức thanh toán',
            'pay_via_balance': 'Thanh toán qua số dư',
            'balance_available': 'Số dư khả dụng',
            'total_price': 'Tổng tiền',
            'total': 'Tổng ',
            'check_out': 'Mua ngay',
            'msg_param': 'Tham số sai',
            'msg_order_field': 'Tải dữ liệu đơn hàng thất bại',
            'msg_select_payment': 'Vui lòng chọn phương thức thanh toán',
            'tip_create_order': 'đang tạo đơn hàng ...',
            'payment_succeeded': 'Thanh toán thành công',
            'payment_fail': 'Thanh toán thất bại',
            'order_no': 'Mã đơn hàng',
            'order_time': 'Thời gian đặt hàng',
            'other': 'Khác',
            'total_amount': 'Tổng số tiền',
            'failure_reason': 'Nguyên nhân thất bại',
            'view_payment_results': 'Xem kết quả thanh toán',
            'payment_failed_to_repay': 'Thanh toán không thể hoàn tiền',
            'top_up': 'Nạp tiền',
            'hot_spot': 'chơi trò chơi',
            'back_home': 'Về trang chủ',
            'msg_create_success': 'Tạo đơn hàng thành công',
            'confirm_title': 'Thanh toán',
            'confirm_msg': 'Thanh toán thất bại',
            'confirm_cancel': 'Hủy',
            'confirm_top_up': 'Nạp tiền',
            'game_odd': 'Lẻ',
            'game_even': 'Chẵn',
            'game_title': 'CHẴN LẺ',
            'game_select_title': 'Chọn kết quả dự đoán của bạn',
            'game_odd_number': 'Số lẻ',
            'game_even_number': 'Số chẵn',
            'game_confirm_selection': 'Xác nhận lựa chọn',
            'game_opening_time': 'Thời gian mở cửa',
            'game_issue': 'Số kỳ',
            'game_number': 'Số',
            'game_results': 'Kết quả',
            'game_submit_err': 'error:order_id không tồn tại!',
            'game_choose_least': 'Vui lòng chọn ít nhất một!',
            'game_success': 'Thành công ',
            'game_error': 'Lỗi',
            'game_confirm': 'Xác nhận',
            'game_confirm_title': 'Nội dung',
            'game_confirm_msg': 'Bạn có chắc chắn với lựa chọn này không?',
            'game_confirm_cancel': 'Hủy ',
            'chart': 'Biểu đồ',
            'close': 'đóng',
            'bulls_eye': 'TRÚNG MỤC TIÊU',
            'trend_recent': 'Xu hướng trong 50 giai đoạn gần đây',
            'number': 'Số',
            'times_without': 'Ngoài thời gian',
            'bet': 'đặt cược'
        },
        'my_order': {
            'title': 'đơn hàng của tôi',
            'operated': 'đã thực hiện',
            'receive': 'Nhận',
            'completed': 'đã hoàn thành',
            'converted': 'đã chuyển đổi',
            'refund': 'Hoàn tiền',
            'item_total_amount': 'Vật phẩm, tổng số tiền',
            'picking_up': 'đang lấy',
            'redeem_points': 'đổi điểm',
            'processing_pick_up': 'đang xử lý để lấy hàng',
            'hot_spot': 'chơi trò chơi',
            'view_details': 'Xem chi tiết',
            'check_tracking': 'Kiểm tra thông tin theo dõi',
            'confirm_receival': 'Xác nhận người nhận',
            'receipt': 'Biên lai',
            'cancel': 'Hủy',
            'confirm_pick_up': 'Xác nhận lấy hàng',
            'not_sales': 'Chưa niêm yết',
            'sales_failed': 'Bán hàng thất bại',
            'sales_success': 'Bán hàng thành công ',
            'waiting_draw': 'Chờ bốc thăm',
            'bonus_countdown': 'đếm ngược thưởng tiền',
            'redeem_success': 'đổi thành công',
            'awarded': 'Tặng',
            'points': 'điểm',
            'fee': 'Phí',
            'cash': 'Tiền mặt',
            'sure': 'nhận',
            'detail_title': 'Chi tiết đơn hàng',
            'detail_copy': 'Sao chép',
            'detail_order_no': 'Mã đơn hàng',
            'detail_order_time': 'Thời gian đặt hàng',
            'detail_type_order': 'Loại đơn hàng',
            'detail_status_payment': 'Trạng thái thanh toán',
            'detail_have_pay': 'Cần thanh toán',
            'detail_did_pay': 'Chưa thanh toán',
            'detail_promotion_status': 'Trạng thái khuyến mãi',
            'detail_promotion_period': 'Thời gian khuyến mãi',
            'detail_promotion_games': 'Trò chơi khuyến mãi',
            'detail_opening_time': 'Thời gian mở cửa',
            'detail_my_choice': 'Lựa chọn của tôi',
            'detail_lottery_numbers': 'Số xổ số',
            'detail_payment_method': 'Phương thức Thanh toán',
            'detail_total_amount': 'Tổng số tiền',
            'detail_amount_paid': 'Số tiền đã thanh toán',
            'detail_re_order': 'đặt hàng lại'
        },
        'user': {
            'account': 'Tài khoản',
            'available_balance': 'Số dư khả dụng',
            'my_points': 'điểm của tôi',
            'active_code': 'Mã sự kiện',
            'your_code': 'mã hoạt động',
            'msg_code': 'Vui lòng điền mã đổi',
            'ok': 'Gửi đi',
            'deposit': 'Tiền gửi',
            'withdraw': 'Rút tiền',
            'confirm_title': 'Xác nhận thay đổi?',
            'confirm_msg': 'đổi ảnh đại diện người dùng',
            'confirm_cancel': 'Hủy',
            'confirm_ok': 'Xác nhận',
            'cancelled': 'đã hủy',
            'profile_title': 'Hồ sơ người dùng',
            'profile_manage_account': 'Quản lý tài khoản của tôi',
            'profile_nickname': 'Biệt hiệu',
            'profile_real_name': 'Họ tên thật',
            'profile_email': 'Email',
            'profile_phone': 'điện thoại',
            'profile_password': 'Mật khẩu',
            'profile_click_change_password': 'Nhấp để đổi mật khẩu',
            'profile_save_the_change': 'Lưu thay đổi',
            'profile_log_out': 'đăng xuất',
            'profile_confirm_title': 'đăng xuất',
            'profile_confirm_msg': 'Xác nhận đăng xuất?',
            'profile_confirm_cancel': 'Hủy',
            'profile_confirm': 'Xác nhận',
            'change_password_title': 'đổi mật khẩu',
            'change_password_current_pwd': 'Nhập mật khẩu hiện tại của bạn',
            'change_password_set_new_pwd': 'đặt mật khẩu mới của bạn',
            'change_password_confirm_new_pwd': 'Xác nhận mật khẩu mới',
            'change_password_confirm_change': 'Xác nhận thay đổi',
            'change_password_msg_current_pwd': 'Vui lòng nhập mật khẩu hiện tại của bạn',
            'change_password_msg_new_pwd': 'Vui lòng nhập mật khẩu mới của bạn',
            'change_password_msg_new_pwd_again': 'Vui lòng nhập lại mật khẩu mới của bạn',
            'change_password_msg_not_match': 'Mật khẩu không khớp',
            'user_rank_title': 'Lịch sử quay thưởng',
            'user_menu_bulletin': 'Tin tức',
            'user_menu_vip': 'VIP',
            'user_menu_binance_pay': 'ngân hàng',
            'user_menu_agent': 'đại lý',
            'user_menu_balance_details': 'Chi tiết số dư',
            'user_menu_lottery_record': 'Lịch sử Xổ số',
            'user_menu_service': 'Dịch vụ',
            'user_menu_about_us': 'Về chúng tôi'
        },
        'balance_detail': {
            'title': 'Chi tiết số dư',
            'total_amount': 'Tổng số tiền',
            'top_up': 'Nạp tiền',
            'accumulated_withdrawal': 'Rút tiền tích lũy',
            'bill_record': 'Lịch sử hóa đơn',
            'consumption_records': 'Lịch sử tiêu thụ',
            'recharge_records': 'Lịch sử nạp tiền',
            'points_center': 'Trung tâm điểm',
            'sign_in': 'đăng nhập để nhận điểm',
            'upgrade_level': 'Nâng cấp để mở khóa chơi mê say!'
        },
        'my_pay': {
            'title': 'Liên kết ví điện tử',
            'phone': 'điện thoại',
            'phone_plac': 'Nhập điện thoại của bạne',
            'binance_id': 'ID Binance',
            'binance_id_plac': 'Nhập ID Binance',
            'pay_nickname': 'Biệt hiệu thanh toán',
            'pay_id': 'ID thanh toán',
            'pay_id_plac': 'Nhập ID thanh toán',
            'tip': 'Vui lòng đảm bảo nhập chính xác tất cả các thông tin, nếu không bạn sẽ không rút được tiền.',
            'bind': 'Liên kết',
            'edit': 'Chỉnh sửa',
            'msg_nickname': 'Vui lòng nhập biệt hiệu thanh toán',
            'confirm_msg': "<b style = 'color: red'> Lưu ý </b>: Chỉ được sửa đổi tên thanh toán một lần!! <br> Biệt hiệu thanh toán:",
            'confirm_title': 'Chỉnh sửa biệt hiệu thanh toán Binance',
            'confirm_cancel': 'Hủy',
            'confirm_cancelled': 'đã hủy',
            'confirm_confirm': 'Xác nhận',
            'msg_phone': 'Vui lòng nhập số điện thoại',
            'msg_binance_id': 'Vui lòng nhập ID Binance',
            'msg_binance_id_format': 'Lỗi định dạng ID Binance',
            'msg_pay_nickname': 'Vui lòng nhập biệt hiệu thanh toán',
            'msg_pay_id': 'Vui lòng nhập ID thanh toán',
            'msg_pay_id_format': 'Lỗi định dạng ID thanh toán',
            'msg_pay_id_length': 'Lỗi độ dài ID thanh toán',
            'msg_binance_pay': 'ID Binance không phải là ID thanh toán, ID thanh toán xem trên trang nhận.',
            'msg_confirm_title': 'Xác nhận thông tin thẻ ngân hàng',
            'msg_confirm_msg1': 'Biệt hiệu thanh toán của bạn',
            'msg_confirm_msg2': 'ID thanh toán của bạn',
            'msg_confirm_msg3': 'Lưu ý: Sau khi xác nhận, không thể hủy liên kết!',
            'msg_confirm_cancel': 'Hủy',
            'msg_confirm_cancelled': 'đã hủy',
            'msg_confirm': 'Xác nhận',
            'bind_success_msg': 'Liên kết thành công, bạn được nhận',
            'select_bank_name':'Vui lòng chọn một ngân hàng',
            'bank_name': 'tên ngân hàng',
            'bank_account': 'Tài khoản ngân hàng',
            'beneficiary_name': 'Tên người thụ hưởng',
            'msg_bank_account': 'Vui lòng điền vào tài khoản thẻ ngân hàng',
            'msg_beneficiary_name': 'Vui lòng điền tên chủ thẻ',
            'msg_confirm_msg4': 'chủ thẻ',
            'msg_confirm_msg5': 'Tài khoản ngân hàng',
        },
        'user_bill': {
            'title': 'Chi tiết số dư',
            'all': 'Toàn bộ',
            'consumption': 'Tiêu thụ',
            'recharge': 'Nạp tiền',
            'income': 'Thu nhập'
        },
        'user_integral': {
            'title': 'Chi tiết số điểm',
            'current_points': 'điểm hiện tại',
            'accumulated_points': 'điểm tích lũy',
            'accumulated_consumption': 'Tiêu thụ tích luỹ',
            'obtained_today': 'Hôm nay nhận được',
            'details_points': 'Chi tiết số điểm',
            'increase_points': 'điểm mới thêm',
            'points_rewarded_purchasing': 'điểm thưởng khi mua vật phẩm',
            'earn_points': 'Kiếm điểm',
            'points_rewarded_sign': 'điểm thưởng đăng nhập hàng ngày',
            'sign_points': 'điểm',
            'sign_details': 'Chi tiết',
            'sign_signed': 'đã đăng nhập',
            'sign_sign': 'đăng nhập',
            'sign_accumulated_sign': 'đăng nhập tích lũy',
            'sign_days': 'Số ngày',
            'sign_tip2_s': 'Nhắc nhở',
            'sign_tip2_e': 'đăng nhập liên tục trong nhiều ngày sẽ đạt số điểm thưởng khủng, đừng quên đăng nhập ~~~',
            'sign_click_load_more': 'Nhấp để tải thêm',
            'sign_success': 'đăng nhập thành công ',
            'sign_awarded': 'được thưởng',
            'sign_sure': 'Chắc chắn',
            'sign_cnum': ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"],
            'sign_msg_signed': 'Bạn đã đăng nhập hôm nay!',
            'detail_title': 'đặt hàng để nhận điểm',
            'detail_phone': 'điện thoại',
            'detail_payment_method': 'Phương thức Thanh toán',
            'detail_pay_with_points': 'Thanh toán bằng điểm',
            'detail_available_points': 'điểm khả dụng',
            'detail_total': 'Tổng',
            'detail_points': 'điểm',
            'detail_check_out': 'Mua ngay',
            'pay_points': 'Thanh toán bằng điểm',
            'detail_parameter_wrong': 'Tham số sai',
            'detail_failed_data': 'Tải dữ liệu đơn hàng thất bại',
            'detail_creating_order': 'đang tạo đơn hàng ...',
            'detail_creating_order_fail': 'Tạo đơn hàng thất bại',
            'detail_status_title': 'đổi hàng thành công',
            'detail_status_check_mailbox': 'Vui lòng kiểm tra hộp thư của bạn, chúng tôi sẽ giao hàng trong 24 giờ',
            'detail_status_view_order': 'Vào xem đơn hàng',
            'detail_status_back_home': 'Về trang chủ',
            'detail_points_title': 'Chi tiết số điểm',
            'my_order_points_title': 'đơn hàng điểm của tôi'
        },
        'recharge': {
            'title': 'Gửi yêu cầu nạp tiền',
            'first_deposit': 'Thưởng nạp lần đầu',
            'use_binance': 'Sử dụng Binance',
            'choose_amount': 'Vui lòng chọn số tiền và tiếp tục',
            'current_balance': 'Lưu ý: Số dư hiện tại',
            'confirm_top_up': 'Xác nhận nạp tiền',
            'application_details': 'Chi tiết yêu cầu nạp tiền',
            'order_number': 'Mã đơn hàng',
            'application_time': 'Thời gian yêu cầu',
            'top_up_amount': 'Số tiền nạp ',
            'top_up_status': 'Trạng thái nạp tiền',
            'reviewing': 'đang duyệt',
            'application_success': 'Yêu cầu thành công',
            'application_failed': 'Yêu cầu thất bại',
            'msg_bind_binance': 'Vui lòng liên kết ví Binance ',
            'msg_minimum_bank': 'Nạp tối thiểu 100',
            'msg_minimum_binance': 'Nạp tối thiểu 1',
            'msg_enter_top_up_amount': 'Vui lòng nhập số tiền nạp',
            'confirm_title': 'Xác nhận chi tiết nạp tiền',
            'confirm_verify_information': 'Vui lòng xác minh thông tin',
            'confirm_tip': 'Dùng bất kỳ tài khoản nào đã liên kết ví Binance sau đây để nạp tiền, nhấp vào góc trên cùng bên phải để xem hướng dẫn.',
            'confirm_our_pay_id': 'ID thanh toán của chúng tôi',
            'confirm_copy': 'Sao chép',
            'confirm_top_up_amount': 'Số tiền nạp',
            'confirm_confirm_top_up': 'Xác nhận nạp tiền',
            'confirm_msg_copy': 'Sao chép thành công',
            'confirm_msg_enter_amount': 'Vui lòng nhập số tiền nạp',
            'confirm_transfer_amount': 'Số tiền chuyển tối thiểu là 1',
            'confirm_alert_mes': 'Vui lòng xác nhận ví Payme liên kết đã dùng để thanh toán cho chúng tôi. <b style =\'color: red\'>Vui lòng đợi 5-10 phút để nhận. </b>Nếu bạn có thắc mắc, vui lòng liên hệ CSKH ngay.',
            'confirm_alert_title': 'Gửi yêu cầu nạp tiền',
            'confirm_alert_cancel': 'Hủy',
            'confirm_alert_msg_cancelled': 'đã hủy',
            'confirm_alert_confirm': 'Xác nhận'
        },
        'withdrawal': {
            'title': 'Rút tiền',
            'link_now_tip': 'Bạn chưa liên kết ví điện tử, vui lòng liên kết và gửi lại yêu cầu rút tiền.',
            'link_now': 'Liên kết ngay ',
            'withdrawal_account': 'Tài khoản rút tiền',
            'phone': 'điện thoại',
            'binance_id': 'ID Binance',
            'nickname': 'Biệt hiệu',
            'pay_id': 'ID thanh toán',
            'withdraw_amount': 'Số tiền rút',
            'balance': 'Số dư',
            'processing_fee': 'Phí xử lý',
            'actual_amount': 'Số tiền thực tế',
            'msg_withdrawal_account': 'Vui lòng chọn tài khoản rút tiền',
            'msg_fill_data': 'Vui lòng điền thông tin',
            'msg_phone': 'Vui lòng nhập số điện thoại',
            'msg_binance_id': 'Vui lòng nhập ID Binance',
            'msg_binance_pay_id': 'Vui lòng nhập ID ví Binance ',
            'msg_pay_id_err': 'Lỗi định dạng ID thanh toán',
            'msg_withdraw_amount': 'Vui lòng nhập số tiền rút',
            'msg_insufficient_balance': 'Không đủ số dư',
            'msg_mini_withdraw': 'Số tiền rút tối thiểu là 160 ',
            'msg_minimum': 'Tối thiểu',
            'msg_to_withdraw': 'Vào rút tiền',
            'audit_tip': 'đã gửi yêu cầu rút tiền, chờ xét duyệt',
            'audit_sure': 'nhận'
        },
        'user_vip': {
            'title': 'Trung tâm thành viên',
            'able_purchase': 'được mua hàng tại',
            'off': 'đóng',
            'level_task1': 'Hoàn thành nạp tiền 1USDT và mua hàng 50 lần để trở thành VIP!',
            'level_task2': 'Phí rút tiền',
            'level_task3': 'Thời gian rút tiền',
            'level_task4': 'H',
            'vip_level_unlocked': 'đã mở khóa VIP',
            'higher_level_unlocked': 'đã mở khóa cấp độ cao hơn',
            'vip_upgrade_requirements': 'Yêu cầu nâng cấp VIP',
            'required_tasks': 'Nhiệm vụ yêu cầu',
            'select_one_below': 'Vui lòng chọn một trong các mục bên dưới',
            'achieved': 'đạt được',
            'conditions_met': 'Chưa đủ điều kiện',
            'accumulated_participation': 'Trò chơi tham gia tích lũy',
            'achieved_top_up': 'Nạp 50 xu tích lũyp',
            'exclusive_coupons': 'Ưu đãi đặc quyền',
            'more_games': 'Thêm trò chơi',
            'need_recharge': 'Cần nạp 50 xu'
        },
        'promoter': {
            'title': 'Quản lý người quảng bá',
            'apply_agency': 'đăng ký làm đại lý về đội của chúng tôi',
            'become_agent': 'Trở thành đại lý',
            'repeatedly_delayed': 'Thao tác tải lên có thể bị chậm trễ, vui lòng không nhấp liên tục và đợi trong giây lát！',
            'current_commission': 'Hoa hồng hiện tại',
            'record': 'Lịch sử',
            'profit_yesterday': 'Lợi nhuận hôm qua',
            'accumulated_withdrawal': 'Rút tiền tích lũy',
            'withdraw': 'Rút tiền',
            'refer_friends': 'Mời bạn bè',
            'total_agent': 'Tổng đại lý',
            'copy_success': 'Sao chép thành công',
            'copy_error': 'Lỗi sao chép',
            'promoter_achievements': 'Thành tích người quảng bá',
            'promoter_orders': 'đơn hàng quảng bá',
            'promoter_ranking': 'Xếp hạng người quảng bá',
            'commission_ranking': 'Xếp hạng hoa hồng',
            'list_title': 'Số lượng đại lý',
            'list_number_agents': 'Số lượng đại lý',
            'list_people': 'Người',
            'list_date_joined': 'Ngày tham gia',
            'list_item': 'Vật phẩm',
            'order_title': 'đơn hàng tích lũy',
            'order_accumulated_orders': 'đơn hàng đã tích lũy',
            'order_commission': 'Hoa hồng',
            'order_time': 'Thời gian đặt hàng',
            'order_mark': 'đánh giá',
            'commission_title': 'Thành tích người quảng bá',
            'commission_accumulated_commission': 'Hoa hồng tích lũy',
            'commission_available': 'Hoa hồng rút được',
            'commission_week': 'Thành viên mới tuần này',
            'commission_month': 'Thành viên mới tháng này',
            'commission_achievement': 'Thành tích',
            'commission_rank_title': 'Xếp hạng hoa hồng',
            'commission_rank_current': 'Xếp hạng hiện tại của bạn',
            'commission_rank_yet': 'Bạn chưa được xếp hạng',
            'rank_title': 'Xếp hạng người quảng bá',
            'cash_record_title': 'Chi tiết rút tiền hoa hồng',
            'cash_record_cash_out': 'Lịch sử xuất khoản',
            'user_cash_title': 'Rút tiền hoa hồng',
            'user_cash_not_link': 'Bạn chưa liên kết ví điện tử, vui lòng liên kết và gửi lại yêu cầu rút tiền.',
            'user_cash_link_now': 'Liên kết ngay',
            'user_cash_service_provider': 'Nhà cung cấp dịch vụ',
            'user_cash_select_account': 'Vui lòng chọn tài khoản rút tiền',
            'user_cash_binance_pay': 'cái ví',
            'user_cash_bank_account': 'Tài khoản Ngân hàng',
            'user_cash_bank_account_pla': 'Vui lòng điền số tài khoản ngân hàng của bạn',
            'user_cash_ifsc_pla': 'Vui lòng điền số tài khoản IFSC của bạn',
            'user_cash_upi_pla': 'Vui lòng điền số tài khoản UPI của bạn',
            'user_cash_withdraw': 'Rút tiền',
            'user_cash_minimum': 'Tối thiểu',
            'user_cash_to_withdraw': 'Vào rút tiền',
            'user_cash_current_commission': 'Hoa hồng hiện tại được rút ',
            'user_cash_account': 'Tài khoản',
            'user_cash_account_pla': 'Vui lòng điền tên người dùng Alipay của bạn',
            'user_cash_current_withdrawal': 'Hoa hồng rút tiền hiện tại',
            'user_cash_to_e_wallet': 'Rút tiền về ví điện tử',
            'user_cash_to_balance': 'Rút tiền về số dư',
            'user_cash_insufficient_balance': 'Không đủ số dư',
            'user_cash_data_format': 'định dạng dữ liệu sai'
        },
        'service': {
            'title': 'Lịch sử tin nhắn',
            'write_email': 'Vui lòng gửi email cho chúng tôi'
        }
    }
};